import isEmpty from 'lodash/isEmpty';
import size from 'lodash/size';
import padStart from 'lodash/padStart';
import {getPenguinsData, isCAN} from '../../../../helpers';
import find from 'lodash/find';

export function getDaysToToday(date) {
  if (date) {
    const currentTime = new Date();
    const targetTime = new Date(date);
    return Math.round(
      (targetTime.getTime() - currentTime.getTime()) / (1000 * 60 * 60 * 24)
    );
  }
  return null;
}

export function checkMembershipStatus(date, status) {
  return getDaysToToday(date) > 0 && status === 'Active';
}

function isCanadianAmex(cardType, country) {
  return cardType === 'American Express' && isCAN(country);
}

export function checkCANumberDigits(transitNumber, institutionNumber) {
  if (isEmpty(transitNumber)) {
    return 'Transit Number cannot be empty.';
  } else if (isEmpty(institutionNumber)) {
    return 'Bank Number cannot be empty.';
  } else if (transitNumber.length > 5 && institutionNumber.length > 3) {
    return 'Please make sure Transit Number has 5 digits and Bank Number has 3 digits.';
  } else if (transitNumber.length > 5) {
    return 'Please make sure Transit Number has 5 digits.';
  } else if (institutionNumber.length > 3) {
    return 'Please make sure Institution Number has 3 digits.';
  }
  return '';
}

export function checkUSNumberDigits(routingNumber) {
  if (routingNumber.length !== 9) {
    return 'Please make sure Routing Number has 9 digits.';
  }
  return '';
}

export function isTransitNumberPotentiallyValid(transitNumber) {
  return !isEmpty(transitNumber) && size(transitNumber) < 6;
}

export function isInstitutionNumberPotentiallyValid(institutionNumber) {
  return !isEmpty(institutionNumber) && size(institutionNumber) < 4;
}

export function getCanRoutingNumber(transitNumber, institutionNumber) {
  return `0${padStart(institutionNumber, 3, '0')}${padStart(
    transitNumber,
    5,
    '0'
  )}`;
}

export function getCountry(countryId) {
  const countries = getPenguinsData(['view_data', 'countries']) || [];
  return find(countries, (country) => String(country.id) === String(countryId)) || {};
}

export function getState(country, stateId) {
  return find(country.states, (state) => String(state.id) === String(stateId)) || {};
}

export function getSettlementAccount(countryId, paymentMethod) {
  const country = getCountry(countryId);
  if (country.name === 'USA' && paymentMethod === PAYMENT_METHOD_CREDIT_CARD) return 'US MEMON Card';
  if (country.name === 'CAN' && paymentMethod === PAYMENT_METHOD_CREDIT_CARD) return 'CA MEMON Card';
  if (country.name === 'USA' && paymentMethod === PAYMENT_METHOD_ACH) return 'US MEMON Check';
  if (country.name === 'CAN' && paymentMethod === PAYMENT_METHOD_ACH) return 'CA MEMON Check';
}

export const PAYMENT_METHOD_CREDIT_CARD = 1;
export const PAYMENT_METHOD_ACH = 0;
